import {
    OBTENER_LOCALIDADES,
    AGREGAR_LOCALIDAD,
    ELIMINAR_LOCALIDAD,
    ACTUALIZAR_LOCALIDAD,
    LOCALIDAD_OK,
    LOCALIDAD_ERROR,
    LOCALIDAD_ACTUAL,
    OBTENER_LOCALIDAD,
    LIMPIAR_LOCALIDADES
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_LOCALIDADES:
            return {
                ...state,
                localidades: action.payload.rows.sort(function Ordenar(x, y) {
                    return ((x.nombre == y.nombre) ? 0 : ((x.nombre > y.nombre) ? 1 : -1));
                })
            }
        case LIMPIAR_LOCALIDADES:
            return {
                ...state,
                localidades: []
            }
        case LOCALIDAD_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case LOCALIDAD_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        case AGREGAR_LOCALIDAD:
            return {
                ...state,
                localidades: [...state.localidades, action.payload],
                formulario: false,
                errorformulario: false
            }
        case LOCALIDAD_ACTUAL:
            return {
                ...state,
                localidad: state.localidades.filter(loc => loc.id === action.payload)
            }
        case ELIMINAR_LOCALIDAD:
            return {
                ...state,
                localidades: state.localidades.filter(loc => loc.id !== action.payload),
                localidad: null
            }
        case ACTUALIZAR_LOCALIDAD:
            return {
                ...state,
                localidades: state.localidades.map(loc => loc.id === action.payload.id ? action.payload : loc),
                localidad: action.payload
            }
        case OBTENER_LOCALIDAD:
            return {
                ...state,
                localidad: action.payload.rows
            }
        default:
            return state;
    }
}